module.exports = __webpack_public_path__ + "img/spelling-textbook-active.cec5f2d0.png";